import { render, staticRenderFns } from "./product_unique_code_check.vue?vue&type=template&id=1422e75e&scoped=true"
import script from "./product_unique_code_check.vue?vue&type=script&lang=js"
export * from "./product_unique_code_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422e75e",
  null
  
)

export default component.exports